import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '../../../store/useUserStore';
import {
  ON_KIDS_DRAFT_NAME,
  ON_KIDS_DRAFT_BIRTH,
  ON_KIDS_DRAFT_GENDER,
  WELCOME_SKIPPED_KEY,
} from '../../../data/define';
import Url from '../../../data/url';
import toast from 'react-hot-toast';
import { useRegisterKidMutation } from '../../../queries';
import useUpdateUser from '../../../hook/useUpdateUser';
import ImgWelcome from '../../../assets/image/img_welcome_kid.png';
import ImgWelcomeWord1 from '../../../assets/image/img_welcom_word_1.svg';
import ImgWelcomeWord2 from '../../../assets/image/img_welcom_word_2.svg';
import IcClose from '../../../assets/image/ic_x.svg';
import FullHeightContainer from '../../../component/common/FullHeightContainer';
import AgreementDialog from '../../../component/login/AgreementDialog';
import { Gender } from '../../../types';
import { useTranslation } from '../../../hook/useTranslation';

export default function WelcomePage() {
  const navigate = useNavigate();
  const user = useUserStore();
  const { t } = useTranslation();
  const { updateUser } = useUpdateUser();
  const [showWordAnimation, setShowWordAnimation] = useState(false);
  const [showWordAnimation2, setShowWordAnimation2] = useState(false);
  const [agreementOpen, setAgreementOpen] = useState(false);
  const [hasAgreementBeenOpen, setHasAgreementBeenOpen] = useState(false);

  const { mutateAsync: registerKid } = useRegisterKidMutation();

  useEffect(() => {
    if (user?.isSignup) {
      setAgreementOpen(true);
    }
  }, [user?.isSignup]);

  // AgreementDialog가 열렸는지 추적
  useEffect(() => {
    if (agreementOpen) {
      setHasAgreementBeenOpen(true);
    }
  }, [agreementOpen]);

  // AgreementDialog가 닫혔을 때 애니메이션 실행
  useEffect(() => {
    // agreementOpen이 false가 되고, 이전에 열렸던 적이 있을 때만 애니메이션 실행
    if (!agreementOpen && hasAgreementBeenOpen) {
      const timer1 = setTimeout(() => {
        setShowWordAnimation(true);
      }, 1000);

      const timer2 = setTimeout(() => {
        setShowWordAnimation2(true);
      }, 2000);

      return () => {
        clearTimeout(timer1);
        clearTimeout(timer2);
      };
    }
  }, [agreementOpen, hasAgreementBeenOpen]);

  const handleClose = async () => {
    localStorage.setItem(WELCOME_SKIPPED_KEY, 'true');
    const kidsData = localStorage.getItem(ON_KIDS_DRAFT_NAME);
    const birthData = localStorage.getItem(ON_KIDS_DRAFT_BIRTH);
    const genderData = localStorage.getItem(ON_KIDS_DRAFT_GENDER);
    if (user.id && kidsData && birthData && genderData) {
      const apiParams = {
        userId: user.id,
        kidName: kidsData,
        kidBirth: birthData,
        gender: genderData as Gender,
      };
      try {
        const response = await registerKid(apiParams);
        const status = response.status;
        if (status >= 200 && status < 300) {
          toast.success(t('welcome.toast_success'));
          await updateUser();
          navigate(Url.Home);
          localStorage.removeItem(ON_KIDS_DRAFT_NAME);
          localStorage.removeItem(ON_KIDS_DRAFT_BIRTH);
          localStorage.removeItem(ON_KIDS_DRAFT_GENDER);
        }
      } catch (error) {
        console.error('Error registering kid:', error);
        toast.error(t('welcome.toast_fail'));
      }
    } else {
      navigate(Url.KidsRegister);
    }
  };

  return (
    <FullHeightContainer>
      <div className="pageInner bg-[#FFF] flex flex-col relative">
        <div className="w-full justify-between flex items-center py-[20px]">
          <div />
          <button type="button" onClick={handleClose} className="cursor-pointer">
            <img src={IcClose} alt="close" className="w-[24px] h-[24px]" />
          </button>
        </div>
        <img
          src={ImgWelcomeWord1}
          alt="welcome word"
          className="absolute"
          style={{
            top: '35%',
            left: '10px',
            opacity: showWordAnimation ? 1 : 0,
            transform: showWordAnimation ? 'translateY(0)' : 'translateY(20px)',
            transition: 'opacity 0.6s ease-out, transform 0.6s ease-out',
            zIndex: 10,
          }}
        />
        <img
          src={ImgWelcomeWord2}
          alt="welcome word 2"
          className="absolute"
          style={{
            top: '40%',
            right: '20px',
            opacity: showWordAnimation2 ? 1 : 0,
            transform: showWordAnimation2 ? 'translateY(0)' : 'translateY(20px)',
            transition: 'opacity 0.6s ease-out, transform 0.6s ease-out',
            zIndex: 10,
          }}
        />
        <div
          className="flex flex-col justify-start items-center"
          style={{
            flexGrow: 1,
            marginLeft: '-20px',
            marginRight: '-20px',
            width: '100vw',
            background:
              'linear-gradient(180deg, rgba(240, 252, 252, 0.00) 0%, var(--brand-Secondary, #F0FCFC) 50%, rgba(240, 252, 252, 0.10) 100%)',
          }}
        >
          <div className="w-full flex flex-col gap-4 items-center justify-start flex-grow">
            <div className="w-full flex flex-col items-center justify-center gap-2 ">
              <div className="text-[16px] font-[500] text-[#363636] text-center">
                {t('welcome.greeting', { name: user?.name || t('welcome.parent_default') })}
              </div>
              <div className="text-[24px] font-[700] text-center leading-[1.4]">
                <div>
                  <span className="text-[#12a9a4]">{t('welcome.title_line1')}</span>
                  <span className="text-[#494949]">{t('welcome.title_line2')}</span>
                </div>
                <div className="text-[#494949]">{t('welcome.title_line3')}</div>
              </div>
            </div>
          </div>
          <div className="relative w-full flex flex-col items-center justify-center gap-2 mt-auto">
            <img
              src={ImgWelcome}
              alt="elepants"
              className="max-w-[180px]"
              style={{
                objectFit: 'contain',
              }}
            />
          </div>
        </div>
        <div className="w-full h-[100px]" />
        <AgreementDialog openType={agreementOpen} onClose={() => setAgreementOpen(false)} />
      </div>
    </FullHeightContainer>
  );
}
